<script setup lang="ts">
import { Download } from '@/shared/icons'
import { Button } from '@/shared/ui/Button'

/**
 * The "Export CSV" control a list page puts in `TableToolbar`'s `#right`.
 *
 * It holds the wording and the glyph and nothing else, so that every list offers the export
 * by the same name. The export itself is `useListCsvExport`: bind its `isExporting` to
 * `loading` and its `download` to `@click`.
 */
withDefaults(
  defineProps<{
    loading?: boolean
    label?: string
  }>(),
  { loading: false, label: 'Export CSV' }
)

const emit = defineEmits<{
  (e: 'click'): void
}>()
</script>

<template>
  <Button :icon="Download" :loading="loading" @click="emit('click')">
    {{ label }}
  </Button>
</template>
